// assets
import { IconDashboard, IconStar } from '@tabler/icons';

// constant
const icons = { IconDashboard, IconStar };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //
const dashboard = {
  id: 'dashboard',
  title: 'Dashboard',
  type: 'group',
  children: [
    {
      id: 'default',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.IconDashboard,
      breadcrumbs: false
    },
    {
      id: 'rating-guru',
      title: 'Rating Guru',
      type: 'item',
      url: '/rating-guru',
      icon: icons.IconStar,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
